/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        /**
         * Countdown JS
         */

        // Set the date we're counting down to
        var countDownDate = new Date(theme.time).getTime();
        // var countdown = document.getElementsByClassName("countdown")[0];
        var daysWrapper = document.getElementsByClassName("days-text")[0];
        var hoursWrapper = document.getElementsByClassName("hours-text")[0];
        var minutesWrapper = document.getElementsByClassName("minutes-text")[0];
        var secondsWrapper = document.getElementsByClassName("seconds-text")[0];

        // Update the count down every 1 second
        var x = setInterval(function() {

          // Get todays date and time
          var now = new Date().getTime();

          // Find the distance between now an the count down date
          var distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          //Display results
          // countdown.innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
          daysWrapper.innerHTML = days;
          hoursWrapper.innerHTML = hours;
          minutesWrapper.innerHTML = minutes;
          secondsWrapper.innerHTML = seconds;

          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            countdown.innerHTML = "EXPIRED";
          }
        }, 1000);
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_tickets': {
      init: function() {
        // Set the date we're counting down to
        var countDownDate = new Date(theme.time).getTime();
        // var countdown = document.getElementsByClassName("countdown")[0];
        var daysWrapper = document.getElementsByClassName("days-text")[0];
        var hoursWrapper = document.getElementsByClassName("hours-text")[0];
        var minutesWrapper = document.getElementsByClassName("minutes-text")[0];
        var secondsWrapper = document.getElementsByClassName("seconds-text")[0];

        // Update the count down every 1 second
        var x = setInterval(function() {

          // Get todays date and time
          var now = new Date().getTime();

          // Find the distance between now an the count down date
          var distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          //Display results
          // countdown.innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
          daysWrapper.innerHTML = days;
          hoursWrapper.innerHTML = hours;
          minutesWrapper.innerHTML = minutes;
          secondsWrapper.innerHTML = seconds;

          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            countdown.innerHTML = "EXPIRED";
          }
        }, 1000);
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
